const getAllLeads = async (bot_id, start, end, page = 1, limit = 100) => {
  const serverDomain = process.env.REACT_APP_SERVER;
  const url = `${serverDomain}/other/leads?bot_id=${bot_id}&start=${start}&end=${end}&page=${page}&limit=${limit}`;

  const option = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await fetch(url, option);
    const data = await res.json();

    if (res.status === 200) {
      return {
        error: false,
        data: data?.result || [],
        pagination: data?.pagination || null,
        message: data?.message || "Success",
      };
    } else {
      return {
        error: true,
        data: [],
        pagination: null,
        message: data?.message || "Failed to fetch leads",
      };
    }
  } catch (err) {
    console.error("Fetch error:", err);
    return {
      error: true,
      data: [],
      pagination: null,
      message: "Network or server error",
    };
  }
};

export default getAllLeads;
